import { apiClient } from '@/services/apiClient'
import type {
  ApiResponse,
  Cart,
  OrderHistoryDetailItem,
  OrderHistoryListItem,
  OrderListQuery,
  PaginatedOrderResponse,
} from '@/interfaces'

export const orderApi = {
  async getMyOrderCart(params: { active_reservation_id: string }): Promise<ApiResponse<Cart>> {
    const response = await apiClient.post('customer/get_my_order_cart', params)
    return response.data
  },

  async confirmCustomerOrderItem(data: {
    item_id: number
    item_name: string
    count: number
    item_amount: number
    total_amount: number
    amount: number
    item_discount: number
    order_comment: string
    active_reservation_id: number
    attribute_id: number
  }): Promise<ApiResponse> {
    const response = await apiClient.post('customer/order_item_confirmation', data)
    return response.data
  },

  async createRestaurantRating(data: { rating: number; tenant_id: string }): Promise<ApiResponse> {
    const response = await apiClient.post('customer/create_restaurant_rating', data)
    return response.data
  },

  async createCallWaiterRequest(data: { tenant_id: string }): Promise<ApiResponse> {
    const response = await apiClient.post('customer/create_table_waiter_request', data)
    return response.data
  },

  async checkPendingSOSStatus(params: {
    tenant_id: string
    customer_id: string
  }): Promise<ApiResponse<{ has_pending_request: boolean }>> {
    const response = await apiClient.post('customer/pending_sos_request_status', params)
    return response.data
  },

  async setSOSStatus(params: { tenant_id: string }): Promise<ApiResponse> {
    const response = await apiClient.post('customer/set_sos_status', params)
    return response.data
  },

  async closeOrderByCustomer(data: { order_id: number }): Promise<ApiResponse> {
    const response = await apiClient.post('customer/order_close_by_customer', data)
    return response.data
  },

  async getOrderList(
    params: OrderListQuery = {}
  ): Promise<ApiResponse<OrderHistoryListItem[] | PaginatedOrderResponse>> {
    const response = await apiClient.get('customer/order_list', {
      params: {
        page: 1,
        per_page: 15,
        ...params,
      },
    })
    return response.data
  },

  async getOrderItems(orderId: string | number): Promise<ApiResponse<OrderHistoryDetailItem[]>> {
    const response = await apiClient.post(`customer/get_order_items/${orderId}`, {})
    return response.data
  },

  async printOrderBill(data: { order_id: string | number }): Promise<ApiResponse<string>> {
    const response = await apiClient.post('customer/print_order_bill', data)
    return response.data
  },
}
